<template>
  <span class="flex items-center font-sriracha">
    <svg
      class="mr-2 w-6"
      viewBox="0 0 73 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M45.5833 25.7656V0H7.5625C5.03411 0 3 2.02715 3 4.54688V92.4531C3 94.9729 5.03411 97 7.5625 97H71.4375C73.9659 97 76 94.9729 76 92.4531V30.3125H50.1458C47.6365 30.3125 45.5833 28.2664 45.5833 25.7656Z"
          fill="#F4F8FF"
        />
        <rect width="27" height="97" fill="#76A9FA" />
        <rect x="4" y="51" width="58" height="6" rx="3" fill="#4B5563" />
        <path
          d="M4 69C4 66.2386 6.23858 64 9 64H63C65.7614 64 68 66.2386 68 69V76C68 78.7614 65.7614 81 63 81H9C6.23858 81 4 78.7614 4 76V69Z"
          fill="#4B5563"
        />
        <circle cx="12" cy="19" r="8" fill="#4B5563" />
        <path d="M44 0H61C67.6274 0 73 5.37258 73 12V32H44V0Z" fill="#F4F8FF" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="73" height="97" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <span
      class="font-semibold text-3xl text-blue-400 leading-none hidden md:inline-block tracking-wider"
      >mi</span
    >
    <span
      class="font-extrabold text-4xl tracking-wide text-gray-100 leading-none hidden md:inline-block"
      >Curriculum</span
    >
  </span>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>